import { Slide } from "react-reveal";

const SMManagementOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don’t post randomly or chase trends without strategy.
                    Every piece of content is part of a structured system
                    designed to grow your audience, strengthen your brand, and
                    convert attention into real business results.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Social Media Strategy & Brand Positioning</h3>
                      <ul>
                        <li>
                          <span>Business & audience analysis</span>
                        </li>
                        <li>
                          <span>
                            Platform selection (Instagram, Facebook, LinkedIn,
                            etc.)
                          </span>
                        </li>
                        <li>
                          <span>Professional social media account setup</span>
                        </li>
                        <li>
                          <span>
                            Content direction & brand voice definition
                          </span>
                        </li>
                        <li>
                          <span>Competitor & market analysis</span>
                        </li>
                        <li>
                          <span>Growth roadmap & posting strategy</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Content Creation System (Visual & Copy)</h3>
                      <ul>
                        <li>
                          <span>Custom branded graphics</span>
                        </li>
                        <li>
                          <span>Carousel posts, stories & static designs</span>
                        </li>
                        <li>
                          <span>
                            Caption writing (engaging & conversion-focused)
                          </span>
                        </li>
                        <li>
                          <span>Content themes & pillars</span>
                        </li>
                        <li>
                          <span>Visual consistency system</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Content Planning & Calendar Management</h3>
                      <ul>
                        <li>
                          <span>Monthly content calendars</span>
                        </li>
                        <li>
                          <span>
                            Campaign planning (promotions, launches, events)
                          </span>
                        </li>
                        <li>
                          <span>Posting schedules optimized per platform</span>
                        </li>
                        <li>
                          <span>Approval workflows</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Account Management & Optimization</h3>
                      <ul>
                        <li>
                          <span>
                            Profile health & optimization (bio, highlights,
                            links)
                          </span>
                        </li>
                        <li>
                          <span>Hashtag strategy & optimization</span>
                        </li>
                        <li>
                          <span>Platform-specific best practices</span>
                        </li>
                        <li>
                          <span>Page structure improvements</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Posting, Scheduling & Execution</h3>
                      <ul>
                        <li>
                          <span>
                            Scheduled content posting across platforms
                          </span>
                        </li>
                        <li>
                          <span>Cross-platform content adaptation</span>
                        </li>
                        <li>
                          <span>Timely posting for maximum reach</span>
                        </li>
                        <li>
                          <span>Content performance monitoring</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Audience Engagement & Community Management</h3>
                      <ul>
                        <li>
                          <span>Responding to comments & messages</span>
                        </li>
                        <li>
                          <span>Engagement with audience & prospects</span>
                        </li>
                        <li>
                          <span>Community interaction strategies</span>
                        </li>
                        <li>
                          <span>Reputation management</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Growth Strategies & Audience Expansion</h3>
                      <ul>
                        <li>
                          <span>Organic growth strategies</span>
                        </li>
                        <li>
                          <span>Trend-based content execution</span>
                        </li>
                        <li>
                          <span>Influencer & collaboration strategies</span>
                        </li>
                        <li>
                          <span>Follower growth campaigns</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Paid Social Media Campaigns</h3>
                      <ul>
                        <li>
                          <span>Ad campaign setup & management</span>
                        </li>
                        <li>
                          <span>Audience targeting & segmentation</span>
                        </li>

                        <li>
                          <span>Budget optimization</span>
                        </li>
                        <li>
                          <span>Creative testing & performance tuning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Analytics, Tracking & Performance Insights</h3>
                      <ul>
                        <li>
                          <span>Engagement & reach tracking</span>
                        </li>
                        <li>
                          <span>Content performance analysis</span>
                        </li>
                        <li>
                          <span>Audience behavior insights</span>
                        </li>
                        <li>
                          <span>Monthly reports & recommendations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Continuous Optimization & Scaling</h3>
                      <ul>
                        <li>
                          <span>Content optimization based on performance</span>
                        </li>
                        <li>
                          <span>Strategy refinement</span>
                        </li>
                        <li>
                          <span>Testing new formats (Reels, videos, Shorts etc.)</span>
                        </li>
                        <li>
                          <span>Scaling high-performing content</span>
                        </li>
                        <li>
                          <span>Influencer engagement & collaborations</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SMManagementOffers;
